import { CommonFragments } from './common.fragments';

export class ManagerTeamFragments {
  /*
   * GraphQL Fragment for the Teams Exhibit
   */
  public static readonly managerTeamFragment = `
    teamExhibit {
      employeeBios {
        ${CommonFragments.teamMemberFragment}
        teamRank
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;
}
